/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/**
 * 权限读写枚举
 */
export enum PermissionSuffixE {
    /**
     * 读权限
     */
    READ = '_R',
    /**
     * 写权限
     */
    WRITE = '_W',
}
